export const OPERATIONS_TIME_ZONE = 'America/Toronto';

const displayOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric', month: 'short', day: 'numeric',
};

// A payroll calendar date must never move when the device timezone changes.
// Also accept the legacy API's midnight timestamp while clients roll forward.
export function formatCalendarDate(value: string | null): string {
  if (!value) return '—';
  const date = new Date(`${value.slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('en-CA', {
    ...displayOptions, timeZone: 'UTC',
  });
}

// Payment timestamps are actual instants; show them in the cafe's local time.
export function formatPaymentDate(value: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('en-CA', {
    ...displayOptions, timeZone: OPERATIONS_TIME_ZONE,
  });
}

export function operationsDate(value: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: OPERATIONS_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(value);
  const part = (type: string) => parts.find(item => item.type === type)?.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}
